import React, { Component } from 'react';
import LoginForm from '../components/LoginForm';
import { connect } from 'react-redux';
import { loginUser, onUserLogin } from '../redux/actions/userActions';
import SimpleSnackbar from "../components/SimpleSnackbar";

export class loginPage extends Component {
  state = {
    email: '',
    pass: ''
  };

  onSubmit = event => {
    event.preventDefault();
    const { email, pass } = this.state;
    this.props.loginUser(email, pass);
  };

  componentDidUpdate() {
    const { authenticated, onUserLogin, history } = this.props;
    if (authenticated) {
      onUserLogin(history);
    }
  }

  render() {
    const { email, pass } = this.state;
    const { loading, errorMessage } = this.props;
    return (
      <div>
        <LoginForm
          email={email}
          pass={pass}
          loading={loading}
          errorMessage={errorMessage}
          onSubmit={this.onSubmit}
          onEmailChange={e => this.setState({ email: e.target.value })}
          onPassChange={e => this.setState({ pass: e.target.value })}
        />
        <SimpleSnackbar />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.ui.loading,
  errorMessage: state.ui.errorMessage,
  authenticated: state.user.authenticated
});

const mapDispatchToProps = {
  loginUser,
  onUserLogin
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(loginPage);
